import * as React from 'react';

// https://github.com/react-icons/react-icons/blob/7bf8bdd2501871a73b7f85fe853d751f5c0f2fb3/packages/react-icons/src/iconContext.tsx

export interface IconContext {
  color?: string;
  size?: string;
  className?: string;
  style?: React.CSSProperties;
  attr?: React.SVGAttributes<SVGElement>;
}

export const DefaultContext: IconContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined,
};

export const IconContext: React.Context<IconContext> =
  React.createContext && React.createContext(DefaultContext);
